<template>
  <v-app>
    <!-- Sidebar -->
    <v-navigation-drawer
      v-if="isAuthenticated && !isLoginPage && !isFirstAccessPage"
      v-model="drawer"
      :rail="rail"
      width="280"
      permanent
      @click="rail = false"
      class="sidebar-premium"
      elevation="0"
    >
      <!-- Logo Minimalista -->
      <div class="logo-container-premium">
        <div class="logo-wrapper">
          <div class="logo-mark">DV</div>
          <div class="logo-text-premium" v-if="!rail">
            Data Vision
          </div>
        </div>
      </div>

      <div class="nav-spacing"></div>

      <!-- Menu Principal -->
      <v-list density="compact" nav class="menu-list-premium">
        <div class="menu-section-title" v-if="!rail && !isFranqueado">GERAL</div>
        <v-list-item
          v-if="!isFranqueado"
          value="dashboard"
          to="/"
          class="menu-item-premium"
          active-class="menu-item-active"
        >
          <template v-slot:prepend>
            <v-icon icon="mdi-home-outline" class="menu-icon"></v-icon>
          </template>
          <v-list-item-title>Início</v-list-item-title>
        </v-list-item>

        <v-list-item
          v-if="!isFranqueado"
          value="favorites"
          to="/favorites"
          class="menu-item-premium"
          active-class="menu-item-active"
        >
          <template v-slot:prepend>
            <v-icon icon="mdi-heart-outline" class="menu-icon"></v-icon>
          </template>
          <v-list-item-title>Favoritos</v-list-item-title>
        </v-list-item>

        <div class="menu-section-title mt-4" v-if="!rail && canAccessDashPowerBI">VISÕES</div>
        
        <!-- Grupo Power BI -->
        <v-list-group v-if="canAccessDashPowerBI" class="menu-group-premium">
          <template #activator="{ props }">
            <v-list-item v-bind="props" class="menu-item-premium">
              <template v-slot:prepend>
                <v-icon icon="mdi-chart-box-outline" class="menu-icon"></v-icon>
              </template>
              <v-list-item-title>Dash Power BI</v-list-item-title>
            </v-list-item>
          </template>

          <v-list-group
            v-for="category in categories"
            :key="category.id"
            class="menu-subgroup-premium"
          >
            <template #activator="{ props }">
              <v-list-item v-bind="props" class="menu-item-premium sub-item">
                <template v-slot:prepend>
                  <v-icon icon="mdi-folder-outline" size="small" class="menu-icon"></v-icon>
                </template>
                <v-list-item-title>{{ category.name }}</v-list-item-title>
              </v-list-item>
            </template>

            <v-list-item
              v-for="report in categoryReports(category.id)"
              :key="report.id"
              class="menu-item-premium sub-sub-item"
              @click="openReport(report)"
            >
              <v-list-item-title>{{ report.name }}</v-list-item-title>
            </v-list-item>
          </v-list-group>
        </v-list-group>

        <!-- Outros Módulos -->
        <div class="menu-section-title mt-4" v-if="!rail && (canAccessFinanceiro || canAccessFranquias || canAccessProdutos)">NEGÓCIO</div>

        <v-list-item
          v-if="canAccessFinanceiro"
          value="financeiro"
          to="/financeiro"
          class="menu-item-premium"
          active-class="menu-item-active"
        >
          <template v-slot:prepend>
            <v-icon icon="mdi-currency-usd" class="menu-icon"></v-icon>
          </template>
          <v-list-item-title>Financeiro</v-list-item-title>
        </v-list-item>

        <v-list-item
          v-if="canAccessFranquias"
          value="franquias"
          to="/franquias"
          class="menu-item-premium"
          active-class="menu-item-active"
        >
          <template v-slot:prepend>
            <v-icon icon="mdi-storefront-outline" class="menu-icon"></v-icon>
          </template>
          <v-list-item-title>Franquias</v-list-item-title>
        </v-list-item>

        <v-list-item
          v-if="canAccessProdutos"
          value="produtos"
          to="/produtos"
          class="menu-item-premium"
          active-class="menu-item-active"
        >
          <template v-slot:prepend>
            <v-icon icon="mdi-package-variant-closed" class="menu-icon"></v-icon>
          </template>
          <v-list-item-title>Produtos</v-list-item-title>
        </v-list-item>

        <div class="menu-section-title mt-4" v-if="!rail && (canAccessUsers || canAccessManageReports || canAccessPageManagement || canAccessMeta)">ADMINISTRAÇÃO</div>

        <v-list-item
          v-if="canAccessUsers"
          value="users"
          to="/users"
          class="menu-item-premium"
          active-class="menu-item-active"
        >
          <template v-slot:prepend>
            <v-icon icon="mdi-account-group-outline" class="menu-icon"></v-icon>
          </template>
          <v-list-item-title>Usuários</v-list-item-title>
        </v-list-item>

        <v-list-item
          v-if="canAccessManageReports"
          value="manage-reports"
          to="/manage-reports"
          class="menu-item-premium"
          active-class="menu-item-active"
        >
          <template v-slot:prepend>
            <v-icon icon="mdi-chart-timeline-variant-shimmer" class="menu-icon"></v-icon>
          </template>
          <v-list-item-title>Gerenciar Relatórios</v-list-item-title>
        </v-list-item>

        <v-list-item
          v-if="canAccessPageManagement"
          value="page-management"
          to="/page-management"
          class="menu-item-premium"
          active-class="menu-item-active"
        >
          <template v-slot:prepend>
            <v-icon icon="mdi-view-dashboard-variant-outline" class="menu-icon"></v-icon>
          </template>
          <v-list-item-title>Páginas</v-list-item-title>
        </v-list-item>

        <v-list-item
          v-if="canAccessMeta"
          value="meta"
          to="/meta"
          class="menu-item-premium"
          active-class="menu-item-active"
        >
          <template v-slot:prepend>
            <v-icon icon="mdi-target" class="menu-icon"></v-icon>
          </template>
          <v-list-item-title>Metas</v-list-item-title>
        </v-list-item>

      </v-list>
      
      <template v-slot:append>
        <div class="sidebar-footer">
          <div class="user-profile-widget" v-if="!rail" @click="$router.push('/profile')">
            <v-avatar size="36" color="var(--primary)" class="text-white">
              {{ userInitials }}
            </v-avatar>
            <div class="user-info">
              <span class="user-name-text">{{ user?.first_name || 'Usuário' }}</span>
              <span class="user-role-text">{{ isAdmin ? 'Administrador' : 'Visualizador' }}</span>
            </div>
            <v-icon size="small" color="var(--text-tertiary)">mdi-chevron-right</v-icon>
          </div>
          <div class="logout-wrapper" v-if="!rail">
            <v-btn
              variant="text"
              class="logout-btn-premium"
              prepend-icon="mdi-logout"
              @click="handleLogout"
              block
            >
              Encerrar Sessão
            </v-btn>
          </div>
        </div>
      </template>
    </v-navigation-drawer>

    <!-- Topbar Flat -->
    <v-app-bar
      v-if="isAuthenticated && !isLoginPage && !isFirstAccessPage"
      elevation="0"
      class="app-bar-premium"
    >
      <v-btn icon="mdi-menu" variant="text" @click="drawer = !drawer" color="var(--text-primary)"></v-btn>
      <v-spacer></v-spacer>
    </v-app-bar>

    <v-main :class="mainClass" class="bg-premium">
      <div class="page-wrapper-premium">
        <router-view />
      </div>
    </v-main>
    

    <TabbedReportViewer ref="globalTabbedReportViewer" />
    
    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      :timeout="5000"
      location="top"
      rounded="pill"
      class="snackbar-premium"
    >
      {{ snackbar.text }}
      <template v-slot:actions>
        <v-btn variant="text" @click="snackbar.show = false">Fechar</v-btn>
      </template>
    </v-snackbar>
    
    <DebugInfo />
  </v-app>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import DebugInfo from './components/DebugInfo.vue'
import TabbedReportViewer from './components/TabbedReportViewer.vue'
import api from './services/api'
import permissionService from './services/permissions'
import { useTheme } from 'vuetify'

export default {
  name: 'App',
  components: {
    DebugInfo,
    TabbedReportViewer
  },
  setup() {
    const theme = useTheme()
    return { theme }
  },
  data() {
    return {
      drawer: true,
      rail: false,
      allReports: [],
      userPermissions: null,
      isLoading: false,
      isDataInitialized: false,
      initializingData: false,
      isDarkTheme: false
    }
  },
  computed: {
    ...mapState(['user', 'token', 'snackbar', 'categories']),
    isAuthenticated() {
      return !!this.token
    },
    isLoginPage() {
      return this.$route.path === '/login'
    },
    isAdmin() {
      return this.user?.is_staff || this.user?.is_superuser || false
    },
    isFranqueado() {
      return this.user?.user_type === 'franqueado'
    },
    isFirstAccessPage() {
      return this.$route.name === 'FirstAccess'
    },
    mainClass() {
      return this.isAuthenticated && !this.isLoginPage && !this.isFirstAccessPage ? 'main-content' : ''
    },
    userInitials() {
      const first = this.user?.first_name?.charAt(0) || 'U'
      const last = this.user?.last_name?.charAt(0) || ''
      return (first + last).toUpperCase()
    },
    userThemePreference() {
      return this.user?.theme_preference || null
    },
    categoryReports() {
      return (categoryId) => {
        const reports = this.allReports.filter(report => {
          const reportCategoryId = report.category?.id || report.category
          const hasAccess = reportCategoryId && (reportCategoryId === categoryId || reportCategoryId == categoryId)
          return hasAccess
        })
        return reports
      }
    },
    canAccessUsers() { return this.isAdmin && !this.isLoading },
    canAccessManageReports() { return this.isAdmin && !this.isLoading },
    canAccessPageManagement() { return this.isAdmin && !this.isLoading },
    canAccessMeta() {
      if (this.isAdmin) return true
      return this.userPermissions && permissionService.hasAccess('meta')
    },
    canAccessDashPowerBI() {
      if (this.isAdmin) return true
      return this.userPermissions && permissionService.hasAccess('reports')
    },
    canAccessFinanceiro() {
      if (this.isAdmin) return true
      return this.userPermissions && permissionService.hasAccess('financeiro')
    },
    canAccessFranquias() {
      if (this.isFranqueado) return true
      if (this.isAdmin) return true
      return this.userPermissions && permissionService.hasAccess('franquias')
    },
    canAccessProdutos() {
      if (this.isAdmin) return true
      return this.userPermissions && permissionService.hasAccess('produtos')
    }
  },
  watch: {
    user: {
      async handler(newUser, oldUser) {
        if (!newUser || !this.isAuthenticated || this.isLoginPage) return
        const switchedUser = !!oldUser && newUser.id !== oldUser.id
        if (switchedUser) {
          permissionService.clearPermissions()
          this.userPermissions = null
          this.isDataInitialized = false
          if (this.$refs.globalTabbedReportViewer) {
            this.$refs.globalTabbedReportViewer.closeAllTabs()
          }
        }
        await this.initializeAppData({ force: switchedUser, skipAuth: true })
      },
      immediate: false
    },
    token(newToken, oldToken) {
      if (newToken && !oldToken) {
        this.isDataInitialized = false
        permissionService.clearPermissions()
        if (!this.isLoginPage) this.initializeAppData({ skipAuth: true })
      } else if (!newToken && oldToken) {
        this.isDataInitialized = false
        this.allReports = []
        this.userPermissions = null
        this.initializingData = false
      }
    },
    isLoginPage(newValue) {
      if (!newValue && this.isAuthenticated) {
        this.initializeAppData({ skipAuth: true })
      }
    },
    userThemePreference(newTheme) {
      if (newTheme) {
        this.applyTheme(newTheme)
      }
    }
  },
  async mounted() {
    this.checkInitialTheme()
    await this.initializeAppData()
  },
  methods: {
    ...mapActions(['logout']),
    normalizeTheme(themeValue) {
      return themeValue === 'dark' ? 'dark' : 'light'
    },
    applyTheme(themeValue) {
      const normalizedTheme = this.normalizeTheme(themeValue)
      this.isDarkTheme = normalizedTheme === 'dark'
      this.theme.global.name = this.isDarkTheme ? 'premiumDark' : 'premiumLight'
      document.documentElement.setAttribute('data-theme', normalizedTheme)
      localStorage.setItem('dv_theme', normalizedTheme)
    },
    checkInitialTheme() {
      const userTheme = this.user?.theme_preference
      if (userTheme) {
        this.applyTheme(userTheme)
        return
      }

      const savedTheme = localStorage.getItem('dv_theme')
      if (savedTheme === 'dark' || savedTheme === 'light') {
        this.applyTheme(savedTheme)
        return
      }

      const prefersDark = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches
      this.applyTheme(prefersDark ? 'dark' : 'light')
    },
    async initializeAppData({ force = false, skipAuth = false } = {}) {
      if (!this.isAuthenticated || this.isLoginPage || this.initializingData) return
      if (this.isDataInitialized && !force) return

      this.initializingData = true
      this.isLoading = true

      try {
        if (!skipAuth) await this.initializeAuth()

        const shouldResetTabs = force || !this.isDataInitialized
        if (shouldResetTabs) {
          this.$nextTick(() => {
            if (this.$refs.globalTabbedReportViewer) {
              this.$refs.globalTabbedReportViewer.closeAllTabs()
            }
          })
        }

        await Promise.all([
          this.loadUserPermissions(),
          this.loadReports(),
          this.loadCategories()
        ])

        this.isDataInitialized = true
      } catch (error) {
        console.error('Erro ao inicializar dados:', error)
      } finally {
        this.initializingData = false
        this.isLoading = false
      }
    },
    async initializeAuth() {
      try { await this.$store.dispatch('initializeAuth') } 
      catch (error) { console.error('Erro:', error) }
    },
    async loadUserPermissions() {
      try { this.userPermissions = await permissionService.loadUserPermissions() } 
      catch (error) { console.error('Erro:', error) }
    },
    async loadReports() {
      try {
        const response = await api.get('/reports/?no_pagination=true')
        this.allReports = response.data.results || response.data
      } catch (error) { console.error('Erro:', error) }
    },
    async loadCategories() {
      try { await this.$store.dispatch('fetchCategories') } 
      catch (error) { console.error('Erro:', error) }
    },
    async handleLogout() {
      try {
        if (this.$refs.globalTabbedReportViewer) this.$refs.globalTabbedReportViewer.closeAllTabs()
        await this.logout()
        permissionService.clearPermissions()
        this.isDataInitialized = false
        this.initializingData = false
        this.allReports = []
        this.userPermissions = null
        this.$router.push('/login')
      } catch (error) {
        console.error('Erro ao fazer logout:', error)
      }
    },
    openReport(report) {
      if (this.$refs.globalTabbedReportViewer) {
        this.$refs.globalTabbedReportViewer.openReport(report)
      }
    }
  },
  provide() {
    return {
      openReport: (report) => {
        if (this.$refs.globalTabbedReportViewer) {
          this.$refs.globalTabbedReportViewer.openReport(report)
        }
      }
    }
  }
}
</script>

<style>
@import './assets/baseCss.css';

.bg-premium {
  background-color: var(--background) !important;
  min-height: 100vh;
}

.page-wrapper-premium {
  padding: var(--spacing-lg) var(--spacing-xl);
  max-width: 1440px;
  margin: 0 auto;
  width: 100%;
}

/* Sidebar Styles */
.sidebar-premium {
  background-color: var(--surface) !important;
  border-right: 1px solid var(--border-light) !important;
  color: var(--text-primary) !important;
}

.logo-container-premium {
  padding: var(--spacing-lg) var(--spacing-xl);
  display: flex;
  align-items: center;
}

.logo-wrapper {
  display: flex;
  align-items: center;
  gap: var(--spacing-sm);
}

.logo-mark {
  width: 32px;
  height: 32px;
  background: var(--primary);
  color: var(--text-on-primary);
  border-radius: var(--radius-sm);
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 14px;
  letter-spacing: -0.5px;
}

.logo-text-premium {
  font-size: 18px;
  font-weight: 600;
  letter-spacing: -0.5px;
  color: var(--text-primary);
}

.nav-spacing {
  height: var(--spacing-md);
}

.menu-list-premium {
  padding: 0 var(--spacing-md) !important;
}

.menu-section-title {
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 1px;
  color: var(--text-tertiary);
  margin: var(--spacing-sm) 0 var(--spacing-xs) var(--spacing-sm);
}

.menu-item-premium {
  border-radius: var(--radius-sm) !important;
  margin-bottom: 2px !important;
  min-height: 36px !important;
  transition: all 0.2s ease !important;
  color: var(--text-secondary) !important;
}

.menu-item-premium:hover {
  background-color: var(--surface-hover) !important;
  color: var(--text-primary) !important;
}

.menu-item-active {
  background-color: var(--surface-hover) !important;
  color: var(--primary) !important;
  font-weight: 500;
}

.menu-item-active .menu-icon {
  color: var(--primary) !important;
}

.menu-icon {
  color: var(--text-tertiary);
  font-size: 20px !important;
  margin-right: var(--spacing-sm) !important;
  transition: color 0.2s ease;
}

.v-list-item__prepend {
  align-items: center !important;
}

.v-list-item-title {
  font-size: 14px !important;
  letter-spacing: -0.2px !important;
  white-space: normal !important;
  overflow: visible !important;
  word-wrap: normal !important;
  word-break: normal !important;
  overflow-wrap: normal !important;
  line-height: 1.3 !important;
  padding-top: 4px;
  padding-bottom: 4px;
}

.sub-item {
  padding-left: 24px !important;
}

.sub-item .v-list-item__content {
  overflow: visible !important;
}

.sub-item .v-list-item-title {
  white-space: nowrap !important;
  overflow: visible !important;
  text-overflow: clip !important;
  word-break: keep-all !important;
  overflow-wrap: normal !important;
}

.sub-sub-item {
  padding-left: 56px !important;
}

/* Footer do Sidebar */
.sidebar-footer {
  padding: var(--spacing-md);
  border-top: 1px solid var(--border-light);
}

.user-profile-widget {
  display: flex;
  align-items: center;
  gap: var(--spacing-sm);
  padding: var(--spacing-sm);
  border-radius: var(--radius-sm);
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.user-profile-widget:hover {
  background-color: var(--surface-hover);
}

.user-info {
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: hidden;
}

.user-name-text {
  font-size: 13px;
  font-weight: 500;
  color: var(--text-primary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.user-role-text {
  font-size: 11px;
  color: var(--text-tertiary);
}

.logout-wrapper {
  margin-top: var(--spacing-sm);
}

.logout-btn-premium {
  font-size: 13px !important;
  color: var(--text-secondary) !important;
  justify-content: flex-start !important;
  letter-spacing: -0.2px !important;
  text-transform: none !important;
}

.logout-btn-premium:hover {
  color: var(--error) !important;
}

/* App Bar Flat */
.app-bar-premium {
  background-color: transparent !important;
  border-bottom: none !important;
}

@media (max-width: 768px) {
  .page-wrapper-premium {
    padding: var(--spacing-md);
  }
}

</style>
